import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDriverSearchDto } from '../../../shared/modules/base/dtos/base-driver-search.dto';

/**
 * Driver DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.DRIVER)
export class ProtoDriverSearchDto extends BaseDriverSearchDto {
	contactShortName?: string;

	displayValue(): string {
		return `${this.code}`;
	}

	shortDisplayValue(): string | null {
		return null;
	}

	periodDisplayValue(): string | null {
		return null;
	}

	extraDisplayValue(): string | null {
		return null;
	}

	pillDisplayValue(): string | null {
		return null;
	}
}
